import React, { useState, useRef, useEffect } from 'react';
import { Menu, Store, Users, CheckCircle, BarChart3, CreditCard, LogOut } from 'lucide-react';

const AdminMenu = ({ onSelect }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center space-x-2 bg-white bg-opacity-20 hover:bg-opacity-30 text-white px-4 py-2 rounded-lg transition-colors"
      >
        <span className="flex items-center gap-2">
          <Menu className="w-4 h-4" />
          <span>Menu</span>
        </span>
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-56 bg-white rounded-lg shadow-lg py-2 z-50">
          <button onClick={() => { setOpen(false); onSelect('business'); }} className="w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-50 flex items-center gap-2">
            <Store className="w-4 h-4" />
            <span>Business List</span>
          </button>
          <button onClick={() => { setOpen(false); onSelect('users'); }} className="w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-50 flex items-center gap-2">
            <Users className="w-4 h-4" />
            <span>Users</span>
          </button>
          <button onClick={() => { setOpen(false); onSelect('approval'); }} className="w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-50 flex items-center gap-2">
            <CheckCircle className="w-4 h-4" />
            <span>Points Approval</span>
          </button>
          <button onClick={() => { setOpen(false); onSelect('sales_history'); }} className="w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-50 flex items-center gap-2">
            <BarChart3 className="w-4 h-4" />
            <span>Transaction History</span>
          </button>
          {/* <button onClick={() => { setOpen(false); onSelect('buy_points'); }} className="w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-50 flex items-center gap-2">
            <CreditCard className="w-4 h-4" />
            <span>Buy Points</span>
          </button> */}
          <div className="border-t my-2"></div>
          <button onClick={() => { setOpen(false); onSelect('logout'); }} className="w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-50 flex items-center gap-2">
            <LogOut className="w-4 h-4" />
            <span>Logout</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default AdminMenu;